import React, {useMemo} from 'react';
import styled, {useTheme} from "styled-components";
import {
    getTierColor,
    getTierNameByValue,
    getTierShortName,
    getTierValue,
    romanNumberConverter,
    romanNumberReverseConverter,
    storePuuIdLocal
} from "../../function";
import EventIcon from "./EventIcon";
import {isNaN} from "lodash";


const progressTierColor = (tier, color) => {
    switch (tier) {
        case "iron":
            return color.tier_cut_iron
        case "bronze":
            return color.tier_cut_bronze
        case "silver":
            return color.tier_cut_silver
        case "gold":
            return color.tier_cut_gold
        case "platinum":
            return color.tier_cut_platinum
        case "emerald":
            return color.tier_cut_emerald
        case "diamond":
            return color.tier_cut_diamond
        case "master":
            return color.tier_cut_master
        case "grandmaster":
            return color.tier_cut_grandmaster
        case "challenger":
            return color.tier_cut_challenger
        case "1st":
            return color.tier_cut_challenger
        default:
            return color.tier_cut_iron
    }
}

const progressTierTextColor = (tier, color) => {
    switch (tier) {
        case "iron":
            return color.tier_cut_text_iron
        case "bronze":
            return color.tier_cut_text_bronze
        case "silver":
            return color.tier_cut_text_silver
        case "gold":
            return color.tier_cut_text_gold
        case "platinum":
            return color.tier_cut_text_platinum
        case "emerald":
            return color.tier_cut_text_emerald
        case "diamond":
            return color.tier_cut_text_diamond
        case "master":
            return color.tier_cut_text_master
        case "grandmaster":
            return color.tier_cut_text_grandmaster
        case "challenger":
            return color.tier_cut_text_challenger
        case "1st":
            return color.tier_cut_text_1st
        default:
            return color.tier_cut_text_iron
    }
}
const Wrapper = styled.div`
  margin-top: 29px;
`;
const ChartBox = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  border: 1px solid ${props => props.theme.color.default_border_color};
  background-color: ${props => props.theme.color.site_main_color};
  border-radius: 6px;
`;
const TierBox = styled.div`
  display: flex;
  flex-direction: row;
  padding-left: 171px;
`;
const Tier = styled.div`
  position: absolute;
  font-size: 14px;
  top: -19px;
  font-weight: 700;
  color: ${props => progressTierTextColor(props.tier, props.theme.color)};
`;

const ExtraTier = styled(Tier)`
  font-weight: 900;
`;

const Chart = styled.div`
  position: absolute;
  display: flex;
  flex-direction: row;
  left: 180px;
  height: 100%;
`;
const Gauge = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  border-top-right-radius: 100px;
  border-bottom-right-radius: 100px;
  position: absolute;
  width: ${props => props.width}px;
  left: 180px;
`;
const PlayerWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  z-index: 2;

  &.light + &.light {
    border-top: 1px solid ${props => props.theme.color.default_border_color};
  }

  &.dark + &.dark {
    border-top: 1px solid ${props => props.theme.color.default_border_color};
  }
`;

const LastTier = styled(ExtraTier)`
  right: 0;
`;

const getTier = ({tier, lp, rankOne}) => {
    try {
        const splitTier = tier.split(' ');
        const division = splitTier[1];
        const tierValue = splitTier[0];
        if (tier === 'CHALLENGER' && lp >= rankOne) {
            return {tier: '1st', division: 1}
        }
        return {tier: tierValue, division}
    } catch (e) {
        console.log(e)
        return {
            tier: 'unranked',
            division: ""
        }
    }
}

const DEFAULT_WIDTH = 600;
const EventChart = ({list, tierOff, toSummoner,}) => {


    const lastTier = useMemo(() => {
        try {
            const lastArray = ['BRONZE', 'SILVER', 'GOLD', 'PLATINUM', 'EMERALD', 'DIAMOND', 'MASTER', 'GRANDMASTER', 'CHALLENGER', '1st'];
            const lastArrayShot = ['B', 'S', 'G', 'P', 'E', 'D', 'M', 'GM', 'C', '1st'];
            const tierValueArray = list.map((data, index) => getTierValue(getTier({tier: data.tier}).tier));
            const minTierValue = Math.min(...tierValueArray);
            const maxTierValue = Math.max(...tierValueArray);

            const maxTier = getTierNameByValue(maxTierValue);
            let maxTierIndex = lastArray.findIndex((data) => data === maxTier) + 1 || 0
            return lastArray[maxTierIndex]
        } catch (e) {
            return ['DIAMOND']
        }
    }, [list])


    const tierArray = useMemo(() => {
        try {
            const tierValueArray = list.map((data, index) => getTierValue(getTier({tier: data.tier}).tier));
            const minTierValue = Math.min(...tierValueArray);
            const maxTierValue = Math.max(...tierValueArray);
            const minTier = getTierNameByValue(minTierValue);
            const maxTier = getTierNameByValue(maxTierValue);
            const array = ['IRON', 'BRONZE', 'SILVER', 'GOLD', 'PLATINUM', 'EMERALD', 'DIAMOND', 'MASTER', 'GRANDMASTER', 'CHALLENGER'];
            let minTierIndex = array.findIndex((data) => data === minTier) || 0;
            let maxTierIndex = array.findIndex((data) => data === maxTier) + 1 || minTierIndex + 1;


            const slicedArray = array.slice(minTierIndex, maxTierIndex);
            return slicedArray
        } catch (e) {
            return ['IRON', 'BRONZE', 'SILVER', 'GOLD', 'PLATINUM', 'EMERALD'];
        }
    }, [list])

    const MAX_VALUE = 900;
    const WRAPPER_VALUE = Math.trunc(MAX_VALUE / tierArray.length);
    const BOUNDARY_VALUE = 855


    const calcMasterOverTier = ({cur_off, lp, tier}) => {
        const tierIndex = tierArray.findIndex((data) => data === tier);
        const tierMultiple = WRAPPER_VALUE * tierIndex;
        const OVER_WIDTH_VALUE = (lp / cur_off);
        const result = WRAPPER_VALUE * OVER_WIDTH_VALUE + tierMultiple


        if (tier === 'CHALLENGER' && result > WRAPPER_VALUE + tierMultiple - 44) {
            return WRAPPER_VALUE + tierMultiple - 44
        }

        if (result > BOUNDARY_VALUE) {
            return BOUNDARY_VALUE
        }

        if (result > WRAPPER_VALUE + tierMultiple) {
            return WRAPPER_VALUE + tierMultiple
        }


        if (isNaN(result) || result < 44) {
            return 44
        }
        return result
    }


    const tierGaugeCalc = ({tier, division, lp}) => {
        const currentDivision = romanNumberReverseConverter(division);
        let WIDTH_VALUE = WRAPPER_VALUE / 4;

        if (tier === '1st') {
            return BOUNDARY_VALUE
        }
        if (tier === 'MASTER') {
            return calcMasterOverTier({cur_off: tierOff.grandmaster_cut_off, lp: lp, tier: tier})
        }
        if (tier === 'GRANDMASTER') {
            return calcMasterOverTier({cur_off: tierOff.challenger_cut_off, lp: lp, tier: tier})
        }
        if (tier === 'CHALLENGER') {
            return calcMasterOverTier({cur_off: tierOff.challenger_1st, lp: lp, tier: tier})
        }


        const tierIndex = tierArray.findIndex((data) => data === tier);
        const tierMultiple = WRAPPER_VALUE * tierIndex;
        const divisionMultiple = WIDTH_VALUE * currentDivision
        const lpMultiple = lp * (WIDTH_VALUE / 100)

        const result = tierMultiple + divisionMultiple + lpMultiple

        if (isNaN(result) || result < 44) {
            return 44
        }

        if (result > BOUNDARY_VALUE) {
            return BOUNDARY_VALUE
        }

        return result
    }


    const getLaneByIndex = (index) => {
        switch (index) {
            case 0:
                return "Top"
            case 1:
                return "Jungle"
            case 2:
                return "Middle"
            case 3:
                return "bot"
            case 4:
                return "supporter"
            default:
                return "Top"
        }
    }
    return (
        <Wrapper>
            <ChartBox>
                {list.map((data, index) => {
                    const currentTier = getTier({tier: data.tier, lp: data.lp, rankOne: tierOff.challenger_1st});
                    return (
                        <PlayerBox
                            region={'kr'}
                            toSummoner={toSummoner}
                            url_name={data?.status === 'Streamer' ? data.name : data?.url_name}
                            division={romanNumberConverter(currentTier.division) || 0}
                            key={data.puu_id}
                            name={data.name}
                            gauge={tierGaugeCalc({
                                tier: currentTier.tier,
                                division: currentTier.division,
                                lp: data.lp
                            })}
                            tier={currentTier.tier}
                            lane={data.position ? data.position : getLaneByIndex(index)}
                            riot_id={data.riot_id_name}
                            riot_tag={data.riot_id_tag_line}
                            puuId={data.puu_id}
                            lp={data.lp}
                            status={data.status}
                        />
                    )
                })}
                <Chart>
                    {tierArray.map((data, index) => {
                        return (
                            <DashedLine tierArray={[`${getTierShortName(data)}`, '', '', '']} tier={data}
                                        width={`${WRAPPER_VALUE}px`} isFirst={index === 0} key={index}/>
                        )
                    })}
                    <LastTier tier={lastTier.toLowerCase()}>{getTierShortName(lastTier)}</LastTier>
                </Chart>
            </ChartBox>
        </Wrapper>
    )
        ;
};

const DashedLineWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  width: ${props => props.width};
  height: 100%;
  background-color: ${props => {
    let color = 'rgba(167, 160, 151, 0.1)';
    if (props.tier === 'BRONZE') {
      color = 'rgba(192, 170, 155, 0.1)'
    } else if (props.tier === 'SILVER') {
      color = 'rgba(183, 187, 203, 0.1)';
    } else if (props.tier === 'GOLD') {
      color = 'rgba(219, 199, 152, 0.1)'
    } else if (props.tier === 'PLATINUM') {
      color = 'rgba(151, 203, 196, 0.1)'
    } else if (props.tier === 'EMERALD') {
      color = 'rgba(110, 207, 148, 0.1)'
    }
    return color
  }};
`;
const Dash = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 1px;
  margin-right: 74px;
  border-right: 1px dashed ${props => {
    let color = 'rgba(167, 160, 151, 0.5)';
    if (props.tier === 'BRONZE') {
      color = 'rgba(135, 107, 38, 0.5)'
    } else if (props.tier === 'SILVER') {
      color = 'rgba(106, 121, 171, 0.5)';
    } else if (props.tier === 'GOLD') {
      color = 'rgba(186, 141, 38, 0.5)'
    } else if (props.tier === 'PLATINUM') {
      color = 'rgba(29, 167, 148, 0.5)'
    } else if (props.tier === 'EMERALD') {
      color = 'rgba(18, 195, 201, 0.5)'
    }
    return color
  }};
`;
const EmptyBox = styled(Dash)`
  border-right: 1px solid ${props => props.theme.color.default_border_color};
`;
const DashedLine = ({tierArray, tier, width, isFirst}) => {
    return (
        <DashedLineWrapper width={width} tier={tier}>
            {tierArray.map((data, index) => {

                if (isFirst && index === 0) {
                    return (
                        <EmptyBox key={index} tier={tier}>
                            <ExtraTier tier={tier.toLowerCase()}>
                                {data}
                            </ExtraTier>
                        </EmptyBox>
                    )
                } else if (index === 0) {
                    return (
                        <Dash key={index} tier={tier}>
                            <ExtraTier tier={tier.toLowerCase()}>
                                {data}
                            </ExtraTier>
                        </Dash>
                    )
                }
                return null
            })}
        </DashedLineWrapper>
    )
}
const PlayerBoxWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-left: 15px;
  width: 180px;
  height: 60px;

  .imgLane {
    width: 20px;
    height: 20px;
  }


`;
const PlayerName = styled.div`
  font-size: 18px;
  font-weight: bold;
  color: ${props => props.theme.color.dark_100};
  margin-left: 5px;
  max-width: 10ch;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;
const IconBox = styled.div`
  padding: 4px;
  border-radius: 100%;
  background: ${props => progressTierColor(props.tier.toLowerCase(), props.theme.color)};
`;

const AbsoluteTierBox = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  right: 0;
`;
const GaugeBar = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  border-top-right-radius: 100px;
  border-bottom-right-radius: 100px;
  flex: 1;
  height: 28px;
  background: ${props => {
    return progressTierColor(props.tier.toLowerCase(), props.theme.color)
  }};
`;

const GaugeTierBox = styled.div`
  position: absolute;
  left: calc(100% + 3px);
  display: flex;
  flex-direction: column;
`;
const GaugeTier = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${props => getTierColor(props.tier)};
  border-radius: 100px;
  width: 38px;
  height: 20px;
  margin-bottom: 2px;
`;
const GaugeTierSpan = styled.span`
  color: #fff;
  font-size: 14px;
  font-weight: bold;
`;
const LPSpan = styled.span`
  line-height: 17px;
  font-size: 14px;
  font-weight: bold;
  color: ${props => getTierColor(props.tier)};
  white-space: nowrap;
`;
const LPTier = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
`;
const PlayerBox = ({
                       name,
                       gauge,
                       tier,
                       division,
                       lane,
                       riot_id,
                       riot_tag,
                       puuId,
                       lp,
                       status,
                       url_name,
                       toSummoner,
                       region
                   }) => {
    const theme = useTheme();

    const tierMemo = useMemo(() => {

        if (tier.toLowerCase() === 'challenger' || tier === '1st') {
            return 'C';
        } else if (tier.toLowerCase() === 'grandmaster') {
            return 'GM';
        } else if (tier.toLowerCase() === 'master') {
            return "M";
        } else if (tier.toLowerCase() === 'unranked') {
            return 'U';
        } else {
            if (tier.length > 0) {
                return tier.toUpperCase()[0] + division;
            }
        }
    }, [tier, division]);

    const changeTier = (tier) => {
        if (tier === '1st') {
            return 'challenger'
        }
        return tier
    }

    return (
        <PlayerWrapper className={theme.color.theme}>
            <PlayerBoxWrapper>
                <img
                    src={`images/icon_s_position_${lane?.toLowerCase()}.svg`}
                    className="imgLane"
                    alt={lane}
                />
                {/*<SmallInfluInfo status={status} width={20} height={20}/>*/}
                <PlayerName
                    onClick={() => {
                        if (toSummoner) {
                            storePuuIdLocal(`${riot_id}-${riot_tag}`, region, puuId);
                        } else {
                            window.open(`/${status === 'Streamer' ? 'strm' : 'pro'}/${url_name}`, "_blank", "noreferrer")
                        }
                    }}>{name}</PlayerName>
                {tier !== 'unranked' &&
                    <Gauge tier={tier} width={gauge}>
                        <GaugeBar tier={tier}>
                            <IconBox tier={tier}>
                                <EventIcon name={name} height={36} width={36} riot_tag={riot_tag} riot_id={riot_id}
                                           puuId={puuId} status={status} url_name={url_name} toSummoner={toSummoner}
                                           region={region}/>
                            </IconBox>
                            <GaugeTierBox>
                                <GaugeTier tier={changeTier(tier)}>
                                    <GaugeTierSpan>
                                        {tierMemo}
                                    </GaugeTierSpan>
                                </GaugeTier>
                                <LPTier>
                                    <LPSpan tier={changeTier(tier)}>
                                        {lp} LP
                                    </LPSpan>
                                </LPTier>
                            </GaugeTierBox>
                        </GaugeBar>
                    </Gauge>}
            </PlayerBoxWrapper>
        </PlayerWrapper>
    )

}

export default EventChart;